import { getRegisterInfoByPathname } from './register-pathname'

type ReportActCommonParams = {
    /** 活动key, 例如 hz_news_year_2024 */
    activity: string

    /** 活动名称, 例如 新春纳福 2024 */
    activityName: string

    /** 页面key, 例如 main_page(可选) */
    page?: string

    /** 页面名称, 例如 首页(可选) */
    pageName?: string

    /** 页面地址 */
    pageUrl?: string
}

type ReportActRequireParams = {
    /** 动作key, 例如 like */
    act: string

    /** 动作名称, 例如点赞 */
    actName: string

    /** 任意扩展字段 */
    [key: string] : any
}

/**
 *
 * @description 动作上报
 */
export function reportAct(params: ReportActRequireParams): void
export function reportAct(params: ReportActCommonParams & ReportActRequireParams): void
export function reportAct(params: Partial<ReportActCommonParams> & ReportActRequireParams): void {
    const pageUrl = params.pageUrl || window.location.href

    if (params.activity && params.activityName) {
        console.log('sensors-tracker.activity', Object.assign({ pageUrl }, params))
        return window['sensors'].track('KbActivityUserAct', Object.assign({ pageUrl }, params))
    }

    const registerPath = getRegisterInfoByPathname(new URL(pageUrl).pathname)

    if (!registerPath) {
        return console.error(`神策埋点失败, activity.report未传递activity或 registerPathname.${new URL(pageUrl).pathname}未找到定义`)
    }

    console.log('sensors-tracker.activity', Object.assign({ pageUrl }, registerPath.params, params))
    return window['sensors'].track('KbActivityUserAct', Object.assign({ pageUrl }, registerPath.params, params))
}


/**
 * 
 * @description 装饰器 动作上报
 */
export function decorateReportAct<T extends (...params: any[]) => any>(params: ReportActRequireParams, callback: T): T
export function decorateReportAct<T extends (...params: any[]) => any>(
    params: ReportActCommonParams & ReportActRequireParams,
    callback: T,
): T
export function decorateReportAct<T extends (...params: any[]) => any>(
    params: Partial<ReportActCommonParams> & ReportActRequireParams,
    callback: T,
): T {
    const pageUrl = window.location.href

    return function () {
        reportAct(Object.assign({ pageUrl }, params))

        return callback.apply(null, arguments)
    } as T
}
